import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13a8bd53"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = ["disabled", "id", "readonly"]
const _hoisted_3 = ["value", "selected"]
const _hoisted_4 = ["type", "id", "disabled", "readonly", "required", "maxlength", "max", "min", "minlength", "value", "placeholder"]
const _hoisted_5 = ["disabled", "type"]
const _hoisted_6 = ["type", "disabled", "id", "required", "readonly", "checked"]
const _hoisted_7 = ["id", "disabled", "required", "readonly", "maxlength", "minlength", "value", "placeholder"]
const _hoisted_8 = {
  key: 5,
  class: "input-count-span"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "baseInput",
    class: _normalizeClass(['_field', { flex: $props.type == 'checkbox' }])
  }, [
    _createElementVNode("label", {
      class: _normalizeClass(['label', { required: $props.required }]),
      for: $props.id
    }, _toDisplayString($props.label), 11, _hoisted_1),
    ($props.type === 'select')
      ? (_openBlock(), _createElementBlock("select", {
          key: 0,
          disabled: $props.readonly,
          id: $props.id,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
          class: "input",
          readonly: $props.readonly
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: option.id,
              selected: option.id === $props.selectedID
            }, _toDisplayString(option.label || option[$props.labelAttribute]), 9, _hoisted_3))
          }), 128))
        ], 40, _hoisted_2))
      : _createCommentVNode("", true),
    (
        $props.type === 'text' ||
          $props.type === 'email' ||
          $props.type === 'password' ||
          $props.type === 'date' ||
          $props.type === 'datetime-local' ||
          $props.type === 'number'
      )
      ? (_openBlock(), _createElementBlock("input", {
          key: 1,
          "data-text": "",
          type: $props.type == 'password' && $setup.isPasswordVisible ? 'text' : $props.type,
          id: $props.id,
          disabled: $props.disable,
          readonly: $props.readonly,
          required: $props.required,
          maxlength: $props.maxLength,
          step: "1",
          max: $props.max,
          min: $props.min,
          minlength: $props.minLength,
          class: _normalizeClass(["input", { 'input--password': $props.type === 'password' }]),
          value: $props.modelValue,
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('blur', $event))),
          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handleInput && $setup.handleInput(...args))),
          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.handleInput && $setup.handleInput(...args))),
          onPaste: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.handleInput && $setup.handleInput(...args))),
          placeholder: $props.placeholder
        }, null, 42, _hoisted_4))
      : _createCommentVNode("", true),
    ($props.type === 'password')
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          disabled: $props.disable,
          class: "input__button",
          type: $setup.isPasswordVisible ? 'text' : 'password',
          onMousedown: _cache[5] || (_cache[5] = ($event: any) => ($setup.showPassword())),
          onMouseup: _cache[6] || (_cache[6] = ($event: any) => ($setup.hidePassword())),
          onTouchstart: _cache[7] || (_cache[7] = ($event: any) => ($setup.showPassword())),
          onTouchend: _cache[8] || (_cache[8] = ($event: any) => ($setup.hidePassword())),
          style: _normalizeStyle(`background: url(${$setup.eye ? $setup.visibleEye : $setup.invisibleEye})`)
        }, null, 44, _hoisted_5))
      : _createCommentVNode("", true),
    ($props.type == 'checkbox')
      ? (_openBlock(), _createElementBlock("input", {
          key: 3,
          type: $props.type,
          disabled: $props.disable,
          id: $props.id,
          required: $props.required,
          readonly: $props.readonly,
          checked: $props.checked,
          onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.checked)))
        }, null, 40, _hoisted_6))
      : _createCommentVNode("", true),
    ($props.type == 'textarea')
      ? (_openBlock(), _createElementBlock("textarea", {
          key: 4,
          id: $props.id,
          disabled: $props.disable,
          required: $props.required,
          readonly: $props.readonly,
          maxlength: $props.maxLength,
          minlength: $props.minLength,
          style: _normalizeStyle(`resize: ${$props.resize}; height: ${$props.height}px;`),
          class: "input input--text-area",
          value: $props.disable ? '' : $props.modelValue,
          onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
          placeholder: $props.placeholder
        }, null, 44, _hoisted_7))
      : _createCommentVNode("", true),
    ($props.hasCounter)
      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($props.modelValue ? $props.modelValue.length : 0) + " / " + _toDisplayString($props.maxLength), 1))
      : _createCommentVNode("", true)
  ], 2))
}